import { emeaAddOnFactorFunctions } from './add-on-factor';
import { emeaSpecificationCertificatesDisplayFunctions } from './certificates';
import { commonDisplayFunctions } from './common-display-fn';
import { emeaCommonFloorSizeFunctions } from './common-floor-size';
import { displayFnMap as finlandDF } from './finland/property-short-list';
import { displayFnMap as italyDF } from './italy/property-short-list';
import { emeaLandlordDisplayFunctions } from './landlord';
import { emeaMinDivisibleSpaceAvailableFunctions } from './min-divisible-space-available';
import { emeaMinMaxAskingRateFunctions } from './min-max-direct-asking-rate';
import { displayFnMap as norwayDF } from './norway/property-short-list';
import { emeaParkingCostFunctions } from './parking-cost';
import { emeaParkingRatioFunctions } from './parking-ratio';
import { displayFnMap as polandAvailabilitiesDF } from './poland/office-availabilities';
import { displayFnMap as polandDF } from './poland/property-short-list';
import { emeaPropertyNameDisplayFunctions } from './property-name';
import { emeaSpecificationAmenitiesDisplayFunctions } from './specification-amenities';
import { displayFnMap as swedenDF } from './sweden/property-short-list';
import { emeaTotalAvailableSpaceDisplayFunctions } from './total-available-space';
import { emeaTransportListDisplayFunctions } from './transport-functions';
import { emeaYearRenovatedDisplayFunctions } from './year-renovated';
import { displayFnMap as emeaIndustrialDF } from './italy/industrial-long-list';
import { emeaDirectAskingRateFunctions } from './direct-asking-rate';

export const emeaNextFivePropertyFn = {
  ...commonDisplayFunctions,
  ...emeaTransportListDisplayFunctions,
  ...emeaSpecificationAmenitiesDisplayFunctions,
  ...emeaLandlordDisplayFunctions,
  ...emeaPropertyNameDisplayFunctions,
  ...emeaTotalAvailableSpaceDisplayFunctions,
  ...emeaYearRenovatedDisplayFunctions,
  ...emeaMinDivisibleSpaceAvailableFunctions,
  ...emeaParkingRatioFunctions,
  ...emeaCommonFloorSizeFunctions,
  ...emeaAddOnFactorFunctions,
  ...emeaParkingCostFunctions,
  ...emeaMinMaxAskingRateFunctions,
  ...emeaDirectAskingRateFunctions,
  ...emeaSpecificationCertificatesDisplayFunctions,
  ...finlandDF,
  ...italyDF,
  ...norwayDF,
  ...swedenDF,
  ...polandDF,
};

export const emeaNextFiveAvailabilityFn = { ...polandAvailabilitiesDF };

export const emeaNextFiveIndustrialFn = { ...emeaIndustrialDF };
